import { DtoBase } from '@/types/Dtos/DtoBase'

export class RemoveShareDto extends DtoBase {
  constructor(email: string) {
    super({ email })
  }
}
